import styled from 'styled-components';
import { media } from '../../../../../helpers/breakpoints';
import { LinkButton } from '../../../../Toolkit/Button/LinkButton';
import { StarIc } from '@dsch/dd-icons';

const SellerRatings = styled.span`
  border: 1px solid ${({ theme }) => theme.colors.GREY_LIGHT};
  border-radius: ${({ theme }) => theme.borderRadius.large};
  padding: ${({ theme }) => theme.spacing.S8};
  display: flex;
  justify-content: space-between;
  gap: ${({ theme }) => theme.spacing.S8};

  ${media.xLarge} {
    padding: ${({ theme }) => `${theme.spacing.S8} ${theme.spacing.S12}`};
    gap: ${({ theme }) => theme.spacing.S12};
  }
`;

const RatingSection = styled.div`
  flex: 1;
  position: relative;

  &:not(:last-child)::after {
    content: '';
    position: absolute;
    top: 2px;
    bottom: 2px;
    right: 0;
    width: 1px;
    background-color: ${({ theme }) => theme.colors.GREY_LIGHT};
  }
`;

const Rating = styled(LinkButton)`
  ${({ theme }) => theme.fontSize.M16}
  display: flex;
  align-items: center;
`;

const RatingNoLink = styled.span`
  ${({ theme }) => theme.fontSize.M16}
  display: flex;
  align-items: center;
`;

const IconWrapper = styled.span`
  height: 24px;
  display: flex;
  align-items: center;
`;

const RatingStarIc = styled(StarIc)`
  margin-left: ${({ theme }) => theme.spacing.S4};
`;

const ConditionalText = styled.span`
  @media screen and (max-width: 1088px) {
    display: none;
  }
`;

export {
  SellerRatings,
  RatingSection,
  Rating,
  RatingNoLink,
  IconWrapper,
  RatingStarIc,
  ConditionalText,
};
